// @ts-nocheck

import { CLASSES } from "./OptionsHandler";
import { preventScroll, releaseScroll } from "../../../Utils/PreventScroll";

/**
 * use custom element for having callbacks to reliably add/remove body class
 */
class Options extends HTMLElement {
    connectedCallback() {
        this.container = this.appendChild(document.createElement("div"));
        if ("function" === typeof this.scrollCallback) {
            this.container.addEventListener("scroll", this.scrollCallback, { passive: true });
        }
        preventScroll(CLASSES.open);
        // this.style.zIndex = (getMaxZIndex() + 1).toString(10);
        this.style.zIndex = "2147483647";
        if (!this.classList.contains(CLASSES.list)) {
            this.classList.add(CLASSES.list);
        }
        this.searchInput.classList.add(CLASSES.activeInput);
        this.dispatchEvent(new CustomEvent("connected", { detail: this }));
    }

    disconnectedCallback() {
        setTimeout(() => releaseScroll(CLASSES.open), 100);
        this.searchInput.classList.remove(CLASSES.activeInput);
        this.style.zIndex = "";
        if ("function" === typeof this.scrollCallback) {
            this.container.removeEventListener("scroll", this.scrollCallback);
        }
        this.empty();
    }

    addScrollListener(cb) {
        if ("function" === typeof cb) {
            this.scrollCallback = cb;
        }
    }

    addOption(option) {
        this.container.appendChild(option);
    }

    /**
     * flush
     */
    empty() {
        this.container.innerHTML = "";
    }

    /**
     * obtain current hidden state
     * @returns {Boolean}
     */
    get hidden() {
        return !this.parentNode;
    }
}

customElements.define("combobox-list", Options);
